export default (theme) => ({
    root: {
        display: 'flex',
        flexFlow: 'column nowrap',
        gap: 20,
        '& > *': {
            margin: 0,
        },
        '& ol, & ul': {
            margin: 0,
            paddingLeft: 24,
        },
        '& ol': {
            listStyle: 'decimal',
        },
        '& ul': {
            listStyle: 'disc',
        },
        '& li': {
            display: 'list-item',
        },
        '& li::marker': {
            color: 'inherit',
        },
    },
    block: {
        display: 'block',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'auto',
    },
    tableHeaderCell: {
        boxSizing: 'border-box',
        padding: 8,
        textAlign: 'left',
        border: `1px solid ${theme.colors.grey[100]}`,
        backgroundColor: theme.colors.grey[100],
        ...theme.typography.body,
        fontWeight: 500,
    },
    tableRowCell: {
        padding: 8,
        textAlign: 'left',
        border: `1px solid ${theme.colors.grey[100]}`,
        ...theme.typography.body,
    },
});
